module.exports = __webpack_public_path__ + "cd8cc2de43e9e6289834c9aacdd126cc.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/support-business/Ung_Dung.svg
// module id = ./assets/images/support-business/Ung_Dung.svg
// module chunks = 0